export const lightTheme = {
  primary: '#1890ff',
  background: '#f0f2f5',
  text: '#000000',
  textReverse: '#ffffff',
  textPrimary: '#000000',
  textSecondary: '#666666',
  secondaryText: '#666666',
  border: '#e8e8e8',
  borderColor: '#e8e8e8',
  buttonBg: '#ffffff',
  buttonText: '#000000',
  buttonHoverBg: '#f5f5f5',
  inputBg: '#E8E8E8',
  placeholderText: '#999999',
  disabledBg: '#f5f5f5',
  cardBg: '#ffffff',
  cardShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  shadowColor: 'rgba(0, 0, 0, 0.1)',
  headerBg: '#f0f0f0',
  footerBg: '#f7f7f7',
  dividerColor: '#e8e8e8',
  tabActiveColor: '#ff4d4f',
  tabHoverColor: '#ff4d4f',
};

export const darkTheme = {
  primary: '#1890ff',
  background: '#141414',
  text: '#ffffff',
  textReverse: '#000000',
  textPrimary: '#ffffff',
  textSecondary: '#999999',
  secondaryText: '#999999',
  border: '#303030',
  borderColor: '#303030',
  buttonBg: '#1f1f1f',
  buttonText: '#ffffff',
  buttonHoverBg: '#2f2f2f',
  inputBg: '#1f1f1f',
  placeholderText: '#666666',
  disabledBg: '#2f2f2f',
  cardBg: '#1f1f1f',
  cardShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
  shadowColor: 'rgba(0, 0, 0, 0.3)',
  headerBg: '#2a2a2a',
  footerBg: '#141414',
  dividerColor: '#303030',
  tabActiveColor: '#ff4d4f',
  tabHoverColor: '#ff4d4f',
};

export default lightTheme;